// components/rate/index.js
import overBasicBehavior from '../../../behaviors/basic'
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    show: Boolean,
    mask: Boolean,
    customStyle: String,
    zIndex: {
      type: Number,
      value: 1
    }
  },
  /**
   * 类似于mixins和traits的组件间代码复用机制
   */
  behaviors: [overBasicBehavior],

  externalClasses: ['custom-class'],

  /**
   * 组件的初始数据
   */
  data: {

  },

  /**
   * 组件的方法列表
   */
  methods: {
    onClick () {
      this.$emit('click')
    },
    noop () {}
  }
})
